module.exports = __webpack_public_path__ + "img/组 17.34fa60af.png";